<template>
  <footer id="continfo" class="footer">
    <nav aria-label="Supplementary">
      <figure>
        <figcaption><a style="color: inherit" target="_blank" href="https://navlin.com">NAVLIN</a></figcaption>
        <ul>
          <li><a target="_blank" href="https://navlin.com/data.php">NAVLIN Data</a></li>
          <li><a target="_blank" href="https://navlin.com/software.php">NAVLIN Software</a></li>
          <li><a target="_blank" href="https://navlin.com/insights.php">NAVLIN Insights</a></li>
          <li><a target="_blank" href="https://www.navlindaily.com">NAVLIN DAILY</a></li>
          <li><router-link to="/scheduleMeeting">Book a Meeting</router-link></li>
        </ul>
      </figure>
      <figure>
        <figcaption><a style="color: inherit" target="_blank" href="https://www.eversana.com">Eversana</a></figcaption>
        <ul>
          <li><a target="_blank" href="https://www.eversana.com/about/">About Us</a></li>
          <li><a target="_blank" href="https://www.eversana.com/solutions/integrated-commercial-services/data-software/">Solutions</a></li>
          <li><a target="_blank" href="https://www.eversana.com/careers/">Careers</a></li>
          <li><a target="_blank" href="https://www.eversana.com/news/">News</a></li>
          <li><router-link to="/contactUs">Contact Us</router-link></li>
        </ul>
      </figure>
    </nav>
    <article>
      <h1>Subscribe to Monthly Newsletter</h1>
      <form name="mc-embedded-subscribe-form" method="post" action="https://submit.jotform.com/submit/222353396958165/" target="_blank">
        <div>
          <input type="email" id="input_3" name="q3_email" aria-label="Your email address (required)" placeholder="Enter business email address" required="">
        </div>
        <input type="hidden" name="formID" value="222353396958165" />
        <input type="hidden" id="JWTContainer" value="" />
        <input type="hidden" id="cardinalOrderNumber" value="" />
        <div class="checkbox-widget">
          <input id="input_4_0" name="q4_acceptNavlin[]" type="checkbox" required="">
          <label for="input_4_0">
            <svg class="sprite ico-checkbox">
              <svg id="ico-checkbox" viewBox="0 0 14 14" data-v-545fd916=""><rect x="1" y="1" width="12" height="12" rx="3" style="fill:var(--color-rect);stroke:var(--color-rect);-moz-transition:fill 200ms, stroke 200ms;" stroke-width="1.5" data-v-545fd916=""></rect><path d="M4 7.5L5.81818 9L9 5" style="stroke:var(--color-check);-moz-transition:stroke 200ms;" stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" data-v-545fd916=""></path></svg>
            </svg>
            By subscribing, you agree to EVERSANA’s <router-link to="/termsAndConditions" rel="noopener">Terms & Conditions</router-link> and <a href="https://www.eversana.com/legal/privacy/" target="_blank" rel="noopener">Privacy Policy</a>.
          </label>
        </div>
        <div>
          <button type="submit"><svg class="sprite ico-footer-subs-arrow-right"><title>Subscribe</title><use xlink:href="#ico-footer-subs-arrow-right"></use></svg></button>
        </div>
      </form>
    </article>
    <article aria-label="Social Links">
      <ul>
        <li><a href="https://www.eversana.com" target="_blank" rel="noopener"><svg class="sprite ico-eversana-logo-graphic"><title>Eversana</title><use xlink:href="#ico-eversana-logo-graphic"></use></svg></a></li>
        <li><a href="https://www.linkedin.com/showcase/navlin-by-eversana" target="_blank" rel="noopener"><svg class="sprite ico-linkedin-in"><title>LinkedIn</title><use xlink:href="#ico-linkedin-in"></use></svg></a></li>
      </ul>
    </article>
    <p>
      <a href="http://eversana.com" target="_blank" rel="noopener"><img src="../assets/img-landing/sprite.svg#logo-eversana-footer" width="249" height="44" alt="Eversana"></a>
      <small>© <time>{{ currentYear }}</time> EVERSANA. All Rights Reserved.<br>
        <a href="https://www.eversana.com/legal/privacy/" target="_blank">Privacy Policy</a>
        &nbsp;|&nbsp;
        <router-link to="/termsAndConditions">Terms & Conditions</router-link>
        &nbsp;|&nbsp;
        <a href="javascript:void(0)" class="optanon-show-settings">Cookie Settings</a>
      </small>
    </p>

    <div style="display: none">
      <svg id="ico-footer-subs-arrow-right" viewBox="0 0 15 12" fill="none">
        <path d="M11 1L14 6L11 11" stroke-width="1.5"></path>
        <path d="M14 6H0" stroke-width="1.5"></path>
      </svg>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        email:'',
      }
    },
    created() {

    },
    computed:{
      isLogin(){
        return this.$store.state.userInfo.username
      }
    },
    methods: {},
  }
</script>

<style lang="scss">
  .footer{
    a{
      color: var(--color-link-static);
    }
  }
</style>
